// Deliberately not @dolfin/lib: narrowSymbol works for any currency, and formatDate returns null (not "N/A")
// so missing dates render nothing on this public page.

export function formatCurrency(amount: number, currency: string, locale: string = "en-GB") {
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      currencyDisplay: "narrowSymbol",
    }).format(amount);
  } catch {
    // Fall back if the currency code isn't recognised by the runtime
    return `${currency} ${amount.toFixed(2)}`;
  }
}

export function formatDate(dateStr: string | undefined | null, month: "short" | "long" = "short") {
  if (!dateStr) return null;
  return new Date(dateStr).toLocaleDateString("en-GB", {
    day: "numeric",
    month,
    year: "numeric",
  });
}
